import React, { useContext, useState, useEffect } from "react";
import { DashboardContext } from '../../context/DashboardContext';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, Legend, Category, Tooltip, BarSeries, DataLabel, Highlight } from '@syncfusion/ej2-react-charts';
import { InputLabel, MenuItem, FormControl, Select, Skeleton } from '@mui/material'
import { FaStar, FaRegStar } from "react-icons/fa";
import chroma from 'chroma-js';

export default function CustoXDemandas({ corFavorito, cicloDemandaKey, tab }) {
    const theme = localStorage.getItem('theme') || 'light'
    const { qtdCustoXDemanda, setQtdCustoXDemanda, getCustoXDemanda, CustoXDemanda, AdicionarGraficoFavorito } = useContext(DashboardContext)
    const [isLoading, setIsLoading] = useState(false)

    const formatCurrency = (value) => {
        const formatter = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        return formatter.format(value);
    };

    const axisLabelRender = (args) => {
        theme == 'light' ? args.labelStyle.color = '#fff' : args.labelStyle.color = '#3f3f46'
        if (args.axis.name === 'primaryXAxis' && args.text.length > 20) {
            args.text = args.text.substring(0, 20) + "...";
          }
        if (args.axis.name === 'primaryYAxis') {
            args.text = formatCurrency(Number(args.text)); 
        }        

    };

    const primaryxAxis = {
        title: '',
        titleStyle: { color: theme == 'light' ? '#fff' : '#3f3f46' },
        labelIntersectAction: 'wrap',
        labelStyle: {
            textAlignment: 'center'
        },
        valueType: 'Category',
        interval: 1,
        majorGridLines: { width: 0 },
        majorTickLines: { width: 0 }
    };
    const primaryyAxis = {
        title: '',
        titleStyle: {
            color: theme === 'light' ? '#fff' : '#3f3f46'
        },
        labelIntersectAction: 'Rotate45', 
        majorTickLines: {
            width: 0
        },
        majorGridLines: {
            width: 0
        },
        lineStyle: {
            width: 0
        },
    };
    

    useEffect(() => {
        if (cicloDemandaKey != "") {
            setIsLoading(true)
            getCustoXDemanda(cicloDemandaKey, qtdCustoXDemanda)
                .then(() => {
                    setIsLoading(false)
                })
        }
    }, [cicloDemandaKey, qtdCustoXDemanda])

    const onPointRender = (args) => {
        const baseColor = '#388933';

        const colorPalette = chroma.scale([chroma(baseColor).darken(1), baseColor, chroma(baseColor).brighten(1)])
            .mode('lab')
            .colors(args.series.dataSource.length);

        args.fill = colorPalette[args.point.index];
    };

    const tooltipRender = (args) => {
        args.text = `${args.point.x}: <b>R$ ${formatCurrency(Number(args.point.y))}</b>`;
    };

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between', padding: '0' }}>
                <h2 className="h2-bsc">
                    <button onClick={() => AdicionarGraficoFavorito("Custo x Demandas")} className='btn-grafico'>{corFavorito("Custo x Demandas") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                    <span style={{ fontWeight: '500' }}>Custo x Demandas</span>
                </h2>
                <FormControl size="small" sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="qtd-demanda-2">Quantidade de demandas</InputLabel>
                    <Select
                        className='span-bsc'
                        labelId="qtd-demanda-label-2"
                        id="qtd-demanda-2"
                        value={qtdCustoXDemanda}
                        label="Quantidade de demandas"
                        onChange={(e) => setQtdCustoXDemanda(parseInt(e.target.value))}
                    >
                        <MenuItem value="5">5</MenuItem>
                        <MenuItem value="10">10</MenuItem>
                        <MenuItem value="15">15</MenuItem>
                        <MenuItem value="20">20</MenuItem>
                        <MenuItem value="30">30</MenuItem>
                        <MenuItem value="40">40</MenuItem>
                        <MenuItem value="1000">Todas</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div style={{ width: '100%', minHeight: '450px' }}>
                {isLoading ?
                    <Skeleton variant="rounded" width="100%" height={450} />
                    :
                    <ChartComponent
                        id={`${tab}-custoxdemanda`}
                        style={{ textAlign: "center" }}
                        legendSettings={{ enableHighlight: true }}
                        primaryXAxis={primaryxAxis}
                        primaryYAxis={primaryyAxis}
                        axisLabelRender={axisLabelRender}
                        chartArea={
                            {
                                border:
                                {
                                    width: 0
                                }
                            }
                        }
                        tooltip={{ enable: true, enableHtml: true }}
                        tooltipRender={tooltipRender}
                        width="1300"
                        height={'100%'}
                        title=''
                        pointRender={onPointRender}
                    >
                        <Inject services={[BarSeries, Legend, Tooltip, Category, DataLabel, Highlight]} />
                        <SeriesCollectionDirective >
                            <SeriesDirective
                                cornerRadius={{ bottomRight: 5, topRight: 5 }}
                                dataSource={CustoXDemanda.sort((a, b) => a.y - b.y)}
                                tooltipMappingName='toolTipMappingName'
                                xName='x'
                                columnSpacing={0.01}
                                yName='y'
                                type='Bar'
                            />
                        </SeriesCollectionDirective>
                    </ChartComponent>
                }
            </div>
        </>
    )
}